export const durationText = durationInMinutes => {
  return durationInMinutes > 90
    ? `${durationInMinutes / 60} hours`
    : `${durationInMinutes} minutes`
}
